import React, { PureComponent } from 'react';
import { injectIntl } from 'react-intl';

import { Image } from 'semantic-ui-react';
import { Checkbox } from 'material-ui';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as templateActions from 'modules/template';
import { List } from 'immutable';

import classNames from 'classnames/bind';
import styles from './PhishingTemplateInTableCheck.css';
const cx = classNames.bind(styles);

class PhishingTemplateInTableCheck extends PureComponent {
  componentDidUpdate(prevProps, prevState) {
    const { TemplateActions, examData, setAllCheck } = this.props;
    // dropdown으로 출력 개수 변경 시 & 다른 페이지로 이동 시 체크 초기화
    if (prevProps.examData !== examData) {
      setAllCheck(false);
      TemplateActions.selectTemplate({
        name: 'examTemplateNoArray',
        value: List([])
      });
      TemplateActions.selectTemplate({
        name: 'serviceTemplateNoArray',
        value: List([])
      });
    }
  }

  // 훈련 템플릿 리스트 체크 이벤트
  selectTarget = () => {
    const { examData, templateInfo, TemplateActions, selectedTemplate, setAllCheck, allChecked } = this.props;

    const templateObj = JSON.parse(JSON.stringify(selectedTemplate));
    const tempList = JSON.parse(JSON.stringify(templateObj.examTemplateNoArray));
    const serviceTempList = JSON.parse(JSON.stringify(templateObj.serviceTemplateNoArray));

    if (templateInfo) {
      // 단일 선택
      let targetNo = -1;
      if (templateInfo.templatePick === 0) {
        // 기본 템플릿
        targetNo = templateInfo.templateNo;
        if (tempList.indexOf(targetNo) > -1) {
          // 체크 해제 시
          tempList.splice(tempList.indexOf(targetNo), 1);
        } else {
          // 체크 시
          tempList.push(targetNo);
        }
      } else if (templateInfo.templatePick === 1) {
        // 사용자 템플릿
        targetNo = templateInfo.serviceTemplateNo;
        if (serviceTempList.indexOf(targetNo) > -1) {
          // 체크 해제 시
          serviceTempList.splice(serviceTempList.indexOf(targetNo), 1);
        } else {
          // 체크 시
          serviceTempList.push(targetNo);
        }
      }
      TemplateActions.selectTemplate({
        name: 'examTemplateNoArray',
        value: List(tempList)
      });
      TemplateActions.selectTemplate({
        name: 'serviceTemplateNoArray',
        value: List(serviceTempList)
      });
    } else {
      // 전체 선택
      if (!allChecked) {
        setAllCheck(true);
        // 전체 선택 체크 시
        tempList.splice(0).push([]);
        serviceTempList.splice(0).push([]);
        examData.map(item => {
          if (item.serviceTemplateNo) {
            serviceTempList.push(item.serviceTemplateNo);
          } else {
            tempList.push(item.templateNo);
          }
        });
      } else {
        // 전체 선택 체크 해제 시
        // indeterminate 상태일 시 전체 선택으로 바뀜
        if (tempList.length + serviceTempList.length < examData.length) {
          setAllCheck(true);
          tempList.splice(0).push([]);
          serviceTempList.splice(0).push([]);
          examData.map(item => {
            if (item.serviceTemplateNo) {
              serviceTempList.push(item.serviceTemplateNo);
            } else {
              tempList.push(item.templateNo);
            }
          });
        } else {
          // 전체 선택된 상태일 시 전체 해제로 바뀜
          setAllCheck(false);
          tempList.splice(0).push([]);
          serviceTempList.splice(0).push([]);
        }
      }
      TemplateActions.selectTemplate({
        name: 'examTemplateNoArray',
        value: List(tempList)
      });
      TemplateActions.selectTemplate({
        name: 'serviceTemplateNoArray',
        value: List(serviceTempList)
      });
    }
  };

  render() {
    // 국제화 처리
    const { selectTarget } = this;
    const { templateInfo, selectedTemplate, allChecked, examData } = this.props;

    const templateObj = JSON.parse(JSON.stringify(selectedTemplate));
    const tempList = JSON.parse(JSON.stringify(templateObj.examTemplateNoArray));
    const serviceTempList = JSON.parse(JSON.stringify(templateObj.serviceTemplateNoArray));

    let checkTemp = false;
    let checkService = false;
    let indeterminate = false;

    if (templateInfo) {
      // 단일 체크 박스
      if (templateInfo.templatePick === 0) {
        // 기본 템플릿
        if (tempList && tempList.indexOf(templateInfo.templateNo) > -1) {
          // 기본 템플릿 체크 시
          checkTemp = true;
        }
      } else {
        // 사용자 템플릿
        if (serviceTempList && serviceTempList.indexOf(templateInfo.serviceTemplateNo) > -1) {
          // 사용자 템플릿 체크 시
          checkService = true;
        }
      }
    } else {
      // 전체 체크 박스
      if (tempList.length > 0) {
        // 선택한 기본 템플릿이 있을 시
        checkTemp = true;
      }
      if (serviceTempList.length > 0) {
        // 선택한 사용자 템플릿이 있을 시
        checkService = true;
      }
    }

    // 전체 선택 체크 박스 '-'로 표시
    if (tempList.length + serviceTempList.length < examData.length) {
      indeterminate = true;
    }

    return (
      <div className={cx('exam-template-checkbox')} onClick={selectTarget}>
        {(() => {
          if (templateInfo) {
            // 단일 선택 체크박스
            return (
              <Checkbox
                checkedIcon={<Image src="/img/exam/list_check_on.png" />}
                checked={checkTemp || checkService}
                disableRipple
              />
            );
          } else {
            // 전체 선택 체크박스
            return (
              <Checkbox
                checkedIcon={
                  indeterminate ? (
                    <Image src="/img/exam/list_check_each.png" />
                  ) : (
                    <Image src="/img/exam/list_check_on.png" />
                  )
                }
                checked={checkTemp || checkService}
                disableRipple
              />
            );
          }
        })()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedTemplate: state.template.get('selectedTemplate')
  };
};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PhishingTemplateInTableCheck));



// WEBPACK FOOTER //
// ./src/script/components/phishingTemplate/PhishingTemplateInTableCheck.js